module.exports = __webpack_public_path__ + "static/media/Sara-4row.b6b12d8a.png";